<template>
    <div class="rectangle-charts">
        <div class="title-analytics">
            <h1>{{ title }}</h1>
            <b-dropdown v-model="changeDays" aria-role="list" position="is-bottom-left">
                <button slot="trigger" slot-scope="{ active }" class="button">
                    <span class="device-days">
                        {{ `${(changeDays === 1) ? 'Últimas 24 horas' : 'Últimos ' + changeDays + ' dias'}` }}
                    </span>
                    <b-icon :icon="active ? 'menu-up' : 'menu-down'" />
                </button>
                <b-dropdown-item :value="1" aria-role="listitem">
                    Últimas 24 horas
                </b-dropdown-item>
                <b-dropdown-item :value="7" aria-role="listitem">
                    Últimos 7 dias
                </b-dropdown-item>
                <b-dropdown-item :value="30" aria-role="listitem">
                    Últimos 30 dias
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="chart">
            <div class="chart-grid">
                <div>
                    <apexcharts class="chart-pie" :options="chartOptions" :series="chartPie" type="pie" />
                </div>
                <div>
                    <ul id="labels">
                        <li>Novos Visitantes</li>
                        <li>Visitantes Recorrentes</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apexcharts from 'vue-apexcharts';
import moment from 'moment';

export default {
    components: {
        apexcharts,
    },
    props: ['series', 'title', 'dateInterval', 'total'],
    data() {
        return {
            changeDays: 1,
        };
    },
    computed: {
        filteredSeries() {
            return '';
        },
        chartPie: {
            get() {
                return this.series;
            },
            set(val) {
                return val;
            }
        },
        chartOptions() {
            return {
                chart: {
                    width: 200,
                    type: 'pie',
                },
                labels: ['Novos Visitantes', 'Visitantes Recorrentes'],
                dataLabels: {
                    enabled: true,
                },
                fill: {
                    type: 'gradient',
                },
                legend: {
                    show: false,
                },
            };
        },
    },
    watch: {
        series() {
            this.mountChartData();
        },
        changeDays(value) {
            const startDate = moment().subtract(value, 'days').format('YYYY-MM-DD');
            this.$emit('change-date', startDate);
        },
    },
    methods: {
        mountChartData() {
            this.chartPie = [parseInt(this.series[0], 10), parseInt(this.series[1], 10)];
        },
    },
};
</script>

<style scoped>
.chart {
    width: 100%;
}

.rectangle-charts {
    width: 100%;
	flex-direction: row;
	margin-top: 30px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	height: 89%;
	background-color: #fff;
}

.chart-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
}

.chart-grid #labels {
    margin-top: 12%;
}

.chart-grid #labels li:nth-child(1)::before {
    content: "";
    background-color: #00bcd4;
    border-radius: 90px;
    padding: 5px;
    width: 5px;
    display: inline-block;
    margin: 0 5px;
}

.chart-grid #labels li:nth-child(2)::before {
    content: "";
    background-color: #55e6a1;
    border-radius: 90px;
    padding: 5px;
    width: 5px;
    display: inline-block;
    margin: 0 5px;
}

@media (max-width: 820px) {
    .chart {
        width: 100%;
    }

    .chart-grid {
        grid-template-columns: 1fr;
        margin-left: 20%;
        margin-top: -10%;
    }
}

@media (min-width: 1420px) {
    .chart {
        width: 100%;
    }
}

@media (min-width: 1620px) {
    .chart {
        width: 80%;
    }
}

@media (min-width: 1720px) {
    .chart {
        width: 72%;
    }
}

@media (min-width: 1820px) {
    .chart {
        width: 70%;
    }
}

@media (min-width: 1920px) {
    .chart {
        width: 65%;
    }
}

.chart-pie {
    display: flex;
    justify-content: space-between;
    float: right;
    width: 89%;
}

.chart-pie #apexcharts9q913pf2 {
    width: 10px;
    height: 10px;
}

.title-analytics {
    display: flex;
    justify-content: space-between;
    padding: 20px;
}

.totals {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 20px;
}

.chartTitle {
    font-size: 15px;
    color: rgb(70 70 70 / 70%);
    margin-bottom: -35px;
}

.chartSubtitle {
    margin-top: 20px;
    font-size: 23px;
    font-weight: bold;
    color: #424242;
}

.title-analytics h1 {
    font-size: 16px;
}

.button {
    all: unset;
    align-items: center;
    display: flex;
    padding-left: 5px;
    padding-right: 5px;
}

.device-days {
    font-size: 10px;
}
</style>
